// Sur téléphone, chaque ligne de `.table` s'affiche en carte (components/_table.scss) :
// une cellule a besoin du titre de sa colonne pour rester lisible hors du tableau.
// Plutôt que de répéter ce titre dans chaque composant, on le recopie ici depuis le
// `<thead>` vers un attribut `data-label` — pour tous les tableaux, présents et futurs.
// Sur PC, l'attribut n'est lu par aucune règle : le rendu ne change pas.

function labelTable(table: HTMLTableElement): void {
  const headRow = table.tHead?.rows[0];
  if (!headRow) return;

  // Titres par index de colonne, en tenant compte des colspan de l'en-tête.
  const labels: string[] = [];
  for (const th of Array.from(headRow.cells)) {
    const text = th.textContent?.trim() ?? "";
    for (let i = 0; i < th.colSpan; i++) labels.push(text);
  }

  for (const body of Array.from(table.tBodies)) {
    for (const row of Array.from(body.rows)) {
      let col = 0;
      for (const cell of Array.from(row.cells)) {
        const label = labels[col] ?? "";
        if (label && cell.getAttribute("data-label") !== label) cell.setAttribute("data-label", label);
        if (!label && cell.hasAttribute("data-label")) cell.removeAttribute("data-label");
        col += cell.colSpan;
      }
    }
  }
}

let scheduled = false;

function labelAll(): void {
  scheduled = false;
  document.querySelectorAll<HTMLTableElement>("table.table").forEach(labelTable);
}

/** Démarre l'étiquetage : une passe par image au plus, quelle que soit la cadence des rendus. */
export function installTableLabels(): void {
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(labelAll);
  };
  // childList seulement : poser nos attributs ne redéclenche pas l'observateur.
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
}
